import React, {MutableRefObject, useCallback, useContext, useEffect, useRef} from "react";
import {useOktaAuth} from "@okta/okta-react";
import {Link} from "react-router-dom";
import OktaSignIn from "@okta/okta-signin-widget";

// @ts-ignore
import {Tokens} from "@okta/okta-auth-js";
import {OktaEnvContext} from "../OktaEnvContext";

const LoginComponent = () => {
    const {oktaAuth} = useOktaAuth();
    const oktaConfig = useContext(OktaEnvContext);
    const widgetRef = useRef() as MutableRefObject<HTMLInputElement>;

    function getOriginalUri(): string {
        const url = localStorage.getItem("media-center.login-success-url");
        if (url) {
            localStorage.removeItem("media-center.login-success-url");
        }
        return url || "";
    }

    const redirectSSO = useCallback((e: any) => {
        e.preventDefault();
        oktaAuth.signInWithRedirect({originalUri: getOriginalUri()});
    }, [oktaAuth]);

    useEffect(() => {
        if (!widgetRef.current) {
            return;
        }

        const widget = new OktaSignIn({
            baseUrl: oktaConfig.issuer?.split("/oauth2")[0],
            authClient: oktaAuth,
            clientId: oktaConfig.clientId,
            redirectUri: window.location.origin + "/login-success",
            useClassicEngine: true,
            features: {
                scrollOnError: false,
                rememberMe: false
            },
            language: "en"
        });

        widget
            .showSignInToGetTokens({
                // Assumes there is an empty element on the page with an id of 'osw-container'
                // @ts-ignore
                el: widgetRef.current
            })
            .then((tokens: Tokens) => {
                oktaAuth.handleLoginRedirect(tokens, getOriginalUri());
            })
            .catch(() => {
            });

        // eslint-disable-next-line consistent-return
        return () => widget.remove();
    }, [oktaAuth, oktaConfig]);

    return (
        <div data-testid="login-component" className="login-component">
            <div ref={widgetRef}/>
            <small className="d-block mt-3">
                <p>
                    Sartorius Employees can&nbsp;
                    <Link
                        to="#"
                        onClick={redirectSSO}
                        data-btn-intent="employee-signin"
                    >
                        sign in here
                    </Link>
                </p>
            </small>
        </div>
    );
};

export default LoginComponent;
